// import axios from "axios";
// import React, { useEffect, useRef, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";

// export default function ForgotPassword() {
//   const navigate = useNavigate();
//   const [data, setData] = useState({
//     email: "",
//   });
//   const [verify, setVerify] = useState({});
//   const [password, setPassword] = useState({});
//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const inputRefs = useRef([]);

//   useEffect(() => {
//     const link = document.createElement("link");
//     link.rel = "stylesheet";
//     link.href = "/css/style.css";
//     document.head.appendChild(link);
//     return () => {
//       document.head.removeChild(link);
//     };
//   }, []);

//   // const handleChange = (element, index) => {
//   //   const value = element.value;
//   //   if (isNaN(value)) return;

//   //   const newOtp = [...otp];
//   //   newOtp[index] = value;
//   //   setOtp(newOtp);
//   //   setVerify({
//   //     email: data.email,
//   //     otp: newOtp.join(""),
//   //   });

//   //   if (value && index < 3) {
//   //     inputRefs.current[index + 1].focus();
//   //   }
//   // };

// const handleChange = (element, index) => {
//   const value = element.value.replace(/\D/g, "");

//   if (!value) return;

//   const newOtp = [...otp];

//   // ✅ Handle paste (1234)
//   if (value.length > 1) {
//     value.split("").slice(0, 4).forEach((digit, i) => {
//       newOtp[i] = digit;
//     });
//     setOtp(newOtp);
//     setVerify({ email: data.email, otp: newOtp.join("") });

//     inputRefs.current[Math.min(value.length - 1, 3)]?.focus();
//     return;
//   }

//   // ✅ Normal typing
//   newOtp[index] = value;
//   setOtp(newOtp);
//   setVerify({ email: data.email, otp: newOtp.join("") });

//   if (index < 3) {
//     inputRefs.current[index + 1]?.focus();
//   }
// };
// const handlePaste = (e) => {
//   e.preventDefault();
//   const pasteData = e.clipboardData.getData("text").replace(/\D/g, "");

//   if (!pasteData) return;

//   const newOtp = [...otp];

//   pasteData.split("").slice(0, 4).forEach((digit, i) => {
//     newOtp[i] = digit;
//   });

//   setOtp(newOtp);
//   setVerify({ email: data.email, otp: newOtp.join("") });

//   inputRefs.current[Math.min(pasteData.length - 1, 3)]?.focus();
// };

//   // const handleKeyDown = (e, index) => {
//   //   if (e.key === "Backspace" && !otp[index] && index > 0) {
//   //     inputRefs.current[index - 1].focus();
//   //   }
//   // };

//   const handleKeyDown = (e, index) => {
//   if (e.key !== "Backspace") return;

//   e.preventDefault();

//   const newOtp = [...otp];

//   // If current input has value → clear it
//   if (newOtp[index]) {
//     newOtp[index] = "";
//     setOtp(newOtp);
//     setVerify({ email: data.email, otp: newOtp.join("") });
//     return;
//   }

//   // If empty → move back & clear previous
//   if (index > 0) {
//     newOtp[index - 1] = "";
//     setOtp(newOtp);
//     setVerify({ email: data.email, otp: newOtp.join("") });
//     inputRefs.current[index - 1]?.focus();
//   }
// };

//   const validateEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(String(email).toLowerCase());
//   };

//   //      send OTP
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const emailValid = validateEmail(data.email);

//       if (!data.email) {
//         Swal.fire({
//           title: "Please enter Email",
//           icon: "warning",
//         });
//       } else if (!emailValid) {
//         Swal.fire({
//           title: "Please enter valid email",
//           icon: "warning",
//         });
//       } else {
//         const res = await axios.post(
//           `${process.env.REACT_APP_BACKEND_BASE_URL}/user/reqOTP`,
//           data,
//         );
//         if (res.status === 200) {
//           setStep((prev) => prev + 1);
//         } else if (res.status === 204) {
//           Swal.fire({
//             title: "This Email is not Register",
//             icon: "warning",
//             timer: 1500,
//           });
//         } else {
//           Swal.fire({
//             title: "OTP Sent Failed",
//             icon: "error",
//           });
//         }
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire({
//         icon: "error",
//         title: "Something went wrong",
//         showConfirmButton: true,
//       });
//     }
//   };

//   //      OTP verify
//   const handleSubmitVerify = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_BACKEND_BASE_URL}/user/verifyOTP`,
//         verify,
//       );
//       if (res.status === 200) {
//         setStep((prev) => prev + 1);
//       } else if (res.status === 205) {
//         Swal.fire({
//           title: "Invalid OTP",
//           icon: "warning",
//         });
//       } else {
//         Swal.fire({
//           title: "OTP Verification Failed",
//           icon: "error",
//         });
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire({
//         icon: "error",
//         title: "Something went wrong",
//         showConfirmButton: true,
//       });
//     }
//   };

//   //      change Password
//   //   const handleSubmitPassword = async (e) => {
//   //     e.preventDefault();

//   //     try {
//   //       if (!password.password) {
//   //         Swal.fire({
//   //           title: "Please enter data",
//   //           icon: "warning",
//   //         });
//   //       } else {
//   //         const res = await axios.put(
//   //           `${process.env.REACT_APP_BACKEND_BASE_URL}/user/forgetPassword`,
//   //           password,
//   //         );
//   //         if (res.status === 200 && res.data.data) {
//   //           Swal.fire({
//   //             icon: "success",
//   //             title: "Your Password Updated Successfully",
//   //             timer: 1500,
//   //           }).then(() => {
//   //             navigate("/login");
//   //           });
//   //         } else {
//   //           // Unsuccessful request
//   //           Swal.fire({
//   //             title: "Password Updated failed",
//   //             icon: "error",
//   //           });
//   //         }
//   //       }
//   //     } catch (err) {
//   //       console.error(err);
//   //       Swal.fire({
//   //         icon: "error",
//   //         title: "Something went wrong",
//   //         showConfirmButton: true,
//   //       });
//   //     }
//   //   };

//   const handleSubmitPassword = async (e) => {
//     e.preventDefault();

//     try {
//       if (!password.password) {
//         Swal.fire({
//           icon: "warning",
//           title: "Please enter password",
//           timer: 1000,
//           showConfirmButton: false,
//         });
//         return;
//       }

//       const res = await axios.put(
//         `${process.env.REACT_APP_BACKEND_BASE_URL}/user/forgetPassword`,
//         password,
//       );

//       if (res.status === 200 && res.data.data) {
//         Swal.fire({
//           icon: "success",
//           title: "Your Password Updated Successfully",
//           timer: 1000,
//           showConfirmButton: false,
//         }).then(() => {
//           navigate("/login");
//         });
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Password Update Failed",
//           timer: 1000,
//           showConfirmButton: false,
//         });
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire({
//         icon: "error",
//         title: "Something went wrong",
//         timer: 1000,
//         showConfirmButton: false,
//       });
//     }
//   };

//   const [showPassword, setShowPassword] = useState(false);

//   const handleTogglePassword = () => {
//     setShowPassword(!showPassword);
//   };

//   const [step, setStep] = useState(1);

//   // const nextStep = () => setStep(prev => prev + 1);
//   const prevStep = () => setStep((prev) => prev - 1);

//   useEffect(() => {
//     const link = document.createElement("link");
//     link.rel = "stylesheet";
//     link.href = "/assets/css/style.css";
//     document.head.appendChild(link);
//     return () => {
//       document.head.removeChild(link); // clean up
//     };
//   }, []);
//   return (
//     <>
//       <style>{`
//       .login-logo {
//   max-width: 140px;
//   transition: 0.3s ease;
//    object-fit: contain;
// }
// .login-logo-wrapper {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin-bottom: 16px;
//   width: 100%;
// }
// .login-logo:hover {
//   transform: scale(1.05);
// }
//         .error-text { color: #dc2626; font-size: 0.875rem; margin-top: 4px; }
//         .error-input { border-color: #dc2626 !important; box-shadow: 0 0 0 3px rgba(220,38,38,0.06); }
//         .btn-gps-primary {
//           background: linear-gradient(90deg,#06b6a4,#06a59a);
//           color: #fff;
//           border: none;
//           padding: 10px 16px;
//           border-radius: 8px;
//           font-weight: 700;
//           cursor: pointer;
//         }
//           .login-pages{font-family: "Spartan", sans-serif;}
//         .btn-gps-primary[disabled] { opacity: 0.7; cursor: not-allowed; transform: none; }
//         .card h3 {
//      font-size: 24px;
//     font-weight: bold;
// }
//      strong {
//     color: #1E2E50;
// }
//       `}</style>

//       <div
//         className="sign-in__wrapper"
//         style={{
//           background:
//             "linear-gradient(135deg, rgb(240 253 253) 0%, rgb(155 222 218 / 73%) 50%, rgb(3 186 187) 100%",
//           minHeight: "100vh",
//           padding: "20px 0",
//         }}
//       >
//         <div className="login-pages">
//           <div className="container-fluid">
//             <div className="row align-items-center justify-content-center">
//               {step === 1 && (
//                 <form onSubmit={handleSubmit}>
//                   <div className="col-lg-6 col-xl-5 mx-auto">
//                     <div
//                       className="card px-4 py-5 gps-card"
//                       style={{
//                         maxWidth: "500px",
//                         margin: "0 auto",
//                         borderRadius: 12,
//                       }}
//                     >
//                       <div className="table-actions d-flex">
//                         <Link to={"/login"}>
//                           <button type="button" className="back-log">
//                             <i className="fa-solid fa-arrow-left"></i>
//                           </button>
//                         </Link>
//                       </div>

//                       <div className="col-lg-12">
//                         <div className="login-logo-wrapper">
//                           <Link to="/">
//                             <img
//                               src="/images/gpslogo.png"
//                               alt="GPS Logo"
//                               className="login-logo"
//                               style={{ cursor: "pointer" }}
//                             />
//                           </Link>
//                         </div>
//                       </div>

//                       <div className="text-center mb-4">
//                         <h3
//                           className="text-gps-primary"
//                           style={{ color: "#0f172a" }}
//                         >
//                           Forget Password
//                         </h3>
//                         {/* <p style={{ color: "#334155" }}>Sign in to your GPS account</p> */}
//                       </div>

//                       <div className="login-input">
//                         <div className="form-group">
//                           <label className="form-label text-gps-primary">
//                             <strong>Email Address *</strong>
//                           </label>
//                           {/* <label>E-mail</label> */}
//                           <div className="d-flex justify-content-between">
//                             <input
//                               type="email"
//                               name="email"
//                               className="form-control"
//                               placeholder="Enter Username or Email ID"
//                               required
//                               autoComplete="email"
//                               autoFocus
//                               onChange={(e) =>
//                                 setData({ ...data, email: e.target.value })
//                               }
//                               style={{
//                                 padding: "10px 12px",
//                                 borderRadius: 8,
//                                 border: "1px solid rgba(2,6,23,0.08)",
//                               }}
//                             />
//                           </div>

//                           <div className="text-center">
//                             <button
//                               type="submit"
//                               className="btn btn-primary mt-4"
//                             >
//                               Send OTP
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </form>
//               )}

//               {step === 2 && (
//                 <form onSubmit={handleSubmitVerify}>
//                   <div className="col-lg-5 col-xl-4 mx-auto">
//                     <div
//                       className="card px-4 py-5 gps-card"
//                       style={{
//                         maxWidth: "500px",
//                         margin: "0 auto",
//                         borderRadius: 12,
//                       }}
//                     >
//                       <div className="table-actions d-flex">
//                         <Link to={"/login"}>
//                           <button type="button" className="back-log">
//                             <i className="fa-solid fa-arrow-left"></i>
//                           </button>
//                         </Link>
//                       </div>
//                       <div className="col-lg-12">
//                         <div className="login-logo-wrapper">
//                           <Link to="/">
//                             <img
//                               src="/images/gpslogo.png"
//                               alt="GPS Logo"
//                               className="login-logo"
//                               style={{ cursor: "pointer" }}
//                             />
//                           </Link>
//                         </div>
//                       </div>

//                       <div className="text-center mb-4">
//                         <h3
//                           className="text-gps-primary"
//                           style={{ color: "#0f172a" }}
//                         >
//                           Forget Password
//                         </h3>
//                         {/* <p style={{ color: "#334155" }}>Sign in to your GPS account</p> */}
//                       </div>
//                       <div className="login-input">
//                         <div className="form-group">
//                           <div className="d-flex justify-content-center gap-4">
//                             {otp.map((data, index) => (
//                               <input
//                                 key={index}
//                                 type="text"
//                                 required
//                                 maxLength="4"
//                                 className="form-control"
//                                 value={data}
//                                 onChange={(e) => handleChange(e.target, index)}
//                                 onKeyDown={(e) => handleKeyDown(e, index)}
//                                  onPaste={handlePaste}  // ✅ paste support
//                                 ref={(el) => (inputRefs.current[index] = el)}
//                                 style={{
//                                   width: "40px",
//                                   padding: "1px",
//                                   height: "50px",
//                                   fontSize: "24px",
//                                   textAlign: "center",
//                                   borderRadius: "8px",
//                                   border: "1px solid rgba(2,6,23,0.08)",
//                                 }}
//                               />
//                             ))}
//                           </div>
//                           <div className="d-flex justify-content-center gap-4 mt-4">
//                             <button
//                               type="button"
//                               className="btn-gps-primary"
//                               style={{ background: "#0f172a" }}
//                               onClick={prevStep}
//                             >
//                               Back
//                             </button>
//                             <button type="submit" className="btn btn-primary">
//                               Verify
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </form>
//               )}

//               {step === 3 && (
//                 <form onSubmit={handleSubmitPassword}>
//                   <div className="col-lg-6 col-xl-5 mx-auto">
//                     <div
//                       className="card px-4 py-5 gps-card"
//                       style={{
//                         maxWidth: "500px",
//                         margin: "0 auto",
//                         borderRadius: 12,
//                       }}
//                     >
//                       <div className="table-actions d-flex">
//                         <Link to={"/login"}>
//                           <button type="button" className="back-log">
//                             <i className="fa-solid fa-arrow-left"></i>
//                           </button>
//                         </Link>
//                       </div>
//                       <div className="col-lg-12">
//                         <div className="login-logo-wrapper">
//                           <Link to="/">
//                             <img
//                               src="/images/gpslogo.png"
//                               alt="GPS Logo"
//                               className="login-logo"
//                               style={{ cursor: "pointer" }}
//                             />
//                           </Link>
//                         </div>
//                       </div>

//                       <div className="text-center mb-4">
//                         <h3
//                           className="text-gps-primary"
//                           style={{ color: "#0f172a" }}
//                         >
//                           Forget Password
//                         </h3>
//                         {/* <p style={{ color: "#334155" }}>Sign in to your GPS account</p> */}
//                       </div>
//                       <div className="login-input">
//                         <div className="form-group">
//                           <div className="d-flex justify-content-between">
//                             <label>Password</label>
//                           </div>
//                           <div className="d-flex justify-content-between gap-3">
//                             <input
//                               type={showPassword ? "text" : "password"}
//                               name="password"
//                               className="form-control"
//                               required
//                               placeholder="Enter Your New Password"
//                               onChange={(e) => {
//                                 setPassword({
//                                   email: data.email,
//                                   password: e.target.value,
//                                 });
//                               }}
//                               style={{
//                                 padding: "10px 12px",
//                                 borderRadius: 8,
//                                 border: "1px solid rgba(2,6,23,0.08)",
//                               }}
//                             />
//                             <div
//                               className="btn btn-secondary"
//                               onClick={handleTogglePassword}
//                             >
//                               {showPassword ? (
//                                 <i
//                                   className="fa-solid fa-eye-slash"
//                                   style={{
//                                     color: "#ffffff",
//                                     position: "initial",
//                                   }}
//                                 ></i>
//                               ) : (
//                                 <i
//                                   className="fa-solid fa-eye"
//                                   style={{
//                                     color: "#ffffff",
//                                     position: "initial",
//                                   }}
//                                 ></i>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       {/* <div className="d-flex gap-5 mt-4">
//                         <button
//                           type="button"
//                           className="btn btn-secondary"
//                           style={{ padding: "10px 12%" }}
//                           onClick={prevStep}
//                         >
//                           Back
//                         </button>

//                         <button type="submit" className="btn btn-login">
//                           Submit
//                         </button>
//                       </div> */}

//                       <div className="d-flex justify-content-center gap-4 mt-4">
//                         <button
//                           type="button"
//                           className="btn-gps-primary"
//                           style={{ background: "#0f172a" }}
//                           onClick={prevStep}
//                         >
//                           Back
//                         </button>
//                         <button type="submit" className="btn btn-primary">
//                           Submit
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </form>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [data, setData] = useState({
    email: "",
  });
  const [verify, setVerify] = useState({});
  const [password, setPassword] = useState({});
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/css/style.css";
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const showPopup = (message, type = "warning") => {
    Swal.fire({
      html: `
      <div style="
        font-family: 'Spartan', sans-serif;
        font-size: 16px;
        color: #0f172a;
        font-weight: 600;
        padding: 8px 0;
      ">
        ${message}
      </div>
    `,
      icon: type,
      background: "#ffffff",
      iconColor:
        type === "warning"
          ? "#f59e0b"
          : type === "error"
          ? "#ef4444"
          : "#10b981",
      showConfirmButton: false,
      timer: 1800,
      timerProgressBar: true,
      customClass: {
        popup: "swal-professional-popup",
      },
    });
  };

  // const handleChange = (element, index) => {
  //   const value = element.value;
  //   if (isNaN(value)) return;

  //   const newOtp = [...otp];
  //   newOtp[index] = value;
  //   setOtp(newOtp);
  //   setVerify({
  //     email: data.email,
  //     otp: newOtp.join(""),
  //   });

  //   if (value && index < 3) {
  //     inputRefs.current[index + 1].focus();
  //   }
  // };

  const handleChange = (element, index) => {
    const value = element.value.replace(/\D/g, "");

    if (!value) return;

    const newOtp = [...otp];

    // ✅ Handle paste (1234)
    if (value.length > 1) {
      value
        .split("")
        .slice(0, 4)
        .forEach((digit, i) => {
          newOtp[i] = digit;
        });
      setOtp(newOtp);
      setVerify({ email: data.email, otp: newOtp.join("") });

      inputRefs.current[Math.min(value.length - 1, 3)]?.focus();
      return;
    }

    // ✅ Normal typing
    newOtp[index] = value;
    setOtp(newOtp);
    setVerify({ email: data.email, otp: newOtp.join("") });

    if (index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").replace(/\D/g, "");

    if (!pasteData) return;

    const newOtp = [...otp];

    pasteData
      .split("")
      .slice(0, 4)
      .forEach((digit, i) => {
        newOtp[i] = digit;
      });

    setOtp(newOtp);
    setVerify({ email: data.email, otp: newOtp.join("") });

    inputRefs.current[Math.min(pasteData.length - 1, 3)]?.focus();
  };

  // const handleKeyDown = (e, index) => {
  //   if (e.key === "Backspace" && !otp[index] && index > 0) {
  //     inputRefs.current[index - 1].focus();
  //   }
  // };

  const handleKeyDown = (e, index) => {
    if (e.key !== "Backspace") return;

    e.preventDefault();

    const newOtp = [...otp];

    // If current input has value → clear it
    if (newOtp[index]) {
      newOtp[index] = "";
      setOtp(newOtp);
      setVerify({ email: data.email, otp: newOtp.join("") });
      return;
    }

    // If empty → move back & clear previous
    if (index > 0) {
      newOtp[index - 1] = "";
      setOtp(newOtp);
      setVerify({ email: data.email, otp: newOtp.join("") });
      inputRefs.current[index - 1]?.focus();
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  //      send OTP
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const emailValid = validateEmail(data.email);

      if (!data.email) {
        showPopup("Please enter Email", "warning");
        return;
      } else if (!emailValid) {
        showPopup("Please enter valid email", "warning");
      } else {
        const res = await axios.post(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/user/reqOTP`,
          data,
        );
        if (res.status === 200) {
          setStep((prev) => prev + 1);
        } else if (res.status === 204) {
          showPopup("This Email is not Registered", "warning");
        } else {
          showPopup("OTP Sent Failed", "error");
        }
      }
    } catch (err) {
      console.error(err);
      showPopup("Something went wrong", "error");
    }
  };

  //      OTP verify
  const handleSubmitVerify = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/user/verifyOTP`,
        verify,
      );
      if (res.status === 200) {
        setStep((prev) => prev + 1);
      } else if (res.status === 205) {
        showPopup("Invalid OTP", "warning");
      } else {
        showPopup("OTP Verification Failed", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        showConfirmButton: true,
      });
    }
  };

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    return regex.test(password);
  };

  // const handleSubmitPassword = async (e) => {
  //   e.preventDefault();

  //   try {
  //     if (!password.password) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "Please enter password",
  //         timer: 2000,
  //         showConfirmButton: false,
  //       });
  //       return;
  //     }

  //     const res = await axios.put(
  //       `${process.env.REACT_APP_BACKEND_BASE_URL}/user/forgetPassword`,
  //       password,
  //     );

  //     if (res.status === 200 && res.data.data) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Your Password Updated Successfully",
  //         timer: 2000,
  //         showConfirmButton: false,
  //       }).then(() => {
  //         navigate("/login");
  //       });
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Password Update Failed",
  //         timer: 2000,
  //         showConfirmButton: false,
  //       });
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Something went wrong",
  //       timer: 2000,
  //       showConfirmButton: false,
  //     });
  //   }
  // };

  const handleSubmitPassword = async (e) => {
    e.preventDefault();

    try {
      // 🔹 1. Empty password validation
      if (!password.password) {
        Swal.fire({
          icon: "warning",
          title: "Please enter password",
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      // 🔹 2. Strong password validation
      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

      if (!passwordRegex.test(password.password)) {
        Swal.fire({
          icon: "warning",
          title:
            "Password must be at least 8 characters and include uppercase, lowercase, number, and special character",
          timer: 2500,
          showConfirmButton: false,
        });
        return;
      }

      // 🔹 3. API call
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/user/forgetPassword`,
        password,
      );

      // 🔹 4. Success response
      if (res.status === 200 && res.data?.data) {
        Swal.fire({
          icon: "success",
          title: "Your Password Updated Successfully",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          navigate("/login");
        });
      } else {
        // 🔹 5. Failed response
        Swal.fire({
          icon: "error",
          title: "Password Update Failed",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (err) {
      console.error(err);

      // 🔹 6. Catch error
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const [step, setStep] = useState(1);

  // const nextStep = () => setStep(prev => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/assets/css/style.css";
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link); // clean up
    };
  }, []);
  return (
    <>
      <style>{`
      .swal-professional-popup {
  border-radius: 14px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
  padding: 22px 28px !important;
  text-align: center;
}

      .login-logo {
  max-width: 140px;
  transition: 0.3s ease;
   object-fit: contain;
}
.login-logo-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
}
.login-logo:hover {
  transform: scale(1.05);
}
        .error-text { color: #dc2626; font-size: 0.875rem; margin-top: 4px; }
        .error-input { border-color: #dc2626 !important; box-shadow: 0 0 0 3px rgba(220,38,38,0.06); }
        .btn-gps-primary {
          background: linear-gradient(90deg,#06b6a4,#06a59a);
          color: #fff;
          border: none;
          padding: 10px 16px;
          border-radius: 8px;
          font-weight: 700;
          cursor: pointer;
        }
          .login-pages{font-family: "Spartan", sans-serif;}
        .btn-gps-primary[disabled] { opacity: 0.7; cursor: not-allowed; transform: none; }
        .card h3 {
     font-size: 24px;
    font-weight: bold;
}
     strong {
    color: #1E2E50;
}
      `}</style>

      <div
        className="sign-in__wrapper"
        style={{
          background:
            "linear-gradient(135deg, rgb(240 253 253) 0%, rgb(155 222 218 / 73%) 50%, rgb(3 186 187) 100%",
          minHeight: "100vh",
          padding: "20px 0",
        }}
      >
        <div className="login-pages">
          <div className="container-fluid">
            <div className="row align-items-center justify-content-center">
              {step === 1 && (
                <form onSubmit={handleSubmit}>
                  <div className="col-lg-6 col-xl-5 mx-auto">
                    <div
                      className="card px-4 py-5 gps-card"
                      style={{
                        maxWidth: "500px",
                        margin: "0 auto",
                        borderRadius: 12,
                      }}
                    >
                      {/* <div className="table-actions d-flex">
                        <Link to={"/login"}>
                          <button type="button" className="back-log">
                            <i className="fa-solid fa-arrow-left"></i>
                          </button>
                        </Link>
                      </div> */}

                      <div className="col-lg-12">
                        <div className="login-logo-wrapper">
                          <Link to="/">
                            <img
                              src="/images/gpslogo.png"
                              alt="GPS Logo"
                              className="login-logo"
                              style={{ cursor: "pointer" }}
                            />
                          </Link>
                        </div>
                      </div>

                      <div className="text-center mb-4">
                        <h3
                          className="text-gps-primary"
                          style={{ color: "#0f172a" }}
                        >
                          Forget Password
                        </h3>
                        {/* <p style={{ color: "#334155" }}>Sign in to your GPS account</p> */}
                      </div>

                      <div className="login-input">
                        <div className="form-group">
                          <label className="form-label text-gps-primary">
                            <strong>Email Address *</strong>
                          </label>
                          {/* <label>E-mail</label> */}
                          <div className="d-flex justify-content-between">
                            <input
                              type="email"
                              name="email"
                              className="form-control"
                              placeholder="Enter Username or Email ID"
                              required
                              autoComplete="email"
                              autoFocus
                              onChange={(e) =>
                                setData({ ...data, email: e.target.value })
                              }
                              style={{
                                padding: "10px 12px",
                                borderRadius: 8,
                                border: "1px solid rgba(2,6,23,0.08)",
                              }}
                            />
                          </div>

                          <div className="text-center">
                            <button
                              type="submit"
                              className="btn btn-primary mt-4"
                            >
                              Send OTP
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              )}

              {step === 2 && (
                <form onSubmit={handleSubmitVerify}>
                  <div className="col-lg-5 col-xl-4 mx-auto">
                    <div
                      className="card px-4 py-5 gps-card"
                      style={{
                        maxWidth: "500px",
                        margin: "0 auto",
                        borderRadius: 12,
                      }}
                    >
                      <div className="table-actions d-flex">
                        <Link to={"/login"}>
                          <button type="button" className="back-log">
                            <i className="fa-solid fa-arrow-left"></i>
                          </button>
                        </Link>
                      </div>
                      <div className="col-lg-12">
                        <div className="login-logo-wrapper">
                          <Link to="/">
                            <img
                              src="/images/gpslogo.png"
                              alt="GPS Logo"
                              className="login-logo"
                              style={{ cursor: "pointer" }}
                            />
                          </Link>
                        </div>
                      </div>

                      <div className="text-center mb-4">
                        <h3
                          className="text-gps-primary"
                          style={{ color: "#0f172a" }}
                        >
                          Forget Password
                        </h3>
                        {/* <p style={{ color: "#334155" }}>Sign in to your GPS account</p> */}
                      </div>
                      <div className="login-input">
                        <div className="form-group">
                          <div className="d-flex justify-content-center gap-4">
                            {otp.map((data, index) => (
                              <input
                                key={index}
                                type="text"
                                required
                                maxLength="4"
                                className="form-control"
                                value={data}
                                onChange={(e) => handleChange(e.target, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                onPaste={handlePaste} // ✅ paste support
                                ref={(el) => (inputRefs.current[index] = el)}
                                style={{
                                  width: "40px",
                                  padding: "1px",
                                  height: "50px",
                                  fontSize: "24px",
                                  textAlign: "center",
                                  borderRadius: "8px",
                                  border: "1px solid rgba(2,6,23,0.08)",
                                }}
                              />
                            ))}
                          </div>
                          <div className="d-flex justify-content-center gap-4 mt-4">
                            <button
                              type="button"
                              className="btn-gps-primary"
                              style={{ background: "#0f172a" }}
                              onClick={prevStep}
                            >
                              Back
                            </button>
                            <button type="submit" className="btn btn-primary">
                              Verify
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              )}

              {step === 3 && (
                <form onSubmit={handleSubmitPassword}>
                  <div className="col-lg-6 col-xl-5 mx-auto">
                    <div
                      className="card px-4 py-5 gps-card"
                      style={{
                        maxWidth: "500px",
                        margin: "0 auto",
                        borderRadius: 12,
                      }}
                    >
                      <div className="table-actions d-flex">
                        <Link to={"/login"}>
                          <button type="button" className="back-log">
                            <i className="fa-solid fa-arrow-left"></i>
                          </button>
                        </Link>
                      </div>
                      <div className="col-lg-12">
                        <div className="login-logo-wrapper">
                          <Link to="/">
                            <img
                              src="/images/gpslogo.png"
                              alt="GPS Logo"
                              className="login-logo"
                              style={{ cursor: "pointer" }}
                            />
                          </Link>
                        </div>
                      </div>

                      <div className="text-center mb-4">
                        <h3
                          className="text-gps-primary"
                          style={{ color: "#0f172a" }}
                        >
                          Forget Password
                        </h3>
                        {/* <p style={{ color: "#334155" }}>Sign in to your GPS account</p> */}
                      </div>
                      <div className="login-input">
                        <div className="form-group">
                          <div className="d-flex justify-content-between">
                            <label>Password</label>
                          </div>
                          <div className="d-flex justify-content-between gap-3">
                            <input
                              type={showPassword ? "text" : "password"}
                              name="password"
                              className="form-control"
                              required
                              placeholder="Enter Your New Password"
                              onChange={(e) => {
                                setPassword({
                                  email: data.email,
                                  password: e.target.value,
                                });
                              }}
                              style={{
                                padding: "10px 12px",
                                borderRadius: 8,
                                // border: "1px solid rgba(2,6,23,0.08)",
                                border:
                                  password.password &&
                                  !validatePassword(password.password)
                                    ? "1px solid #ef4444"
                                    : "1px solid rgba(2,6,23,0.08)",
                              }}
                            />

                            <div
                              className="btn btn-primary"
                              onClick={handleTogglePassword}
                            >
                              {showPassword ? (
                                <i
                                  className="fa-solid fa-eye-slash"
                                  style={{
                                    color: "#ffffff",
                                    position: "initial",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="fa-solid fa-eye"
                                  style={{
                                    color: "#ffffff",
                                    position: "initial",
                                  }}
                                ></i>
                              )}
                            </div>
                          </div>
                          <p
                            style={{
                              fontSize: "12px",
                              color: "#64748b",
                              marginTop: "6px",
                            }}
                          >
                            Password must be at least 8 characters and include
                            uppercase, lowercase, number and special character.
                          </p>
                        </div>
                      </div>

                      <div className="d-flex justify-content-center gap-4 mt-4">
                        <button
                          type="button"
                          className="btn-gps-primary"
                          style={{ background: "#0f172a" }}
                          onClick={prevStep}
                        >
                          Back
                        </button>
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
